import { useCtaHref } from '@/components/astro/cta-button/cta-button.tsx';
import { useFreePlan } from '@/hooks/use-free-plan-availability';
import * as m from '@/paraglide/messages';
import '@/styles/astro/new-design.css';
import { Button } from '@listening/frontend/components/radix/button';
import { Link } from '@tanstack/react-router';

export function Banner() {
  const { isInFreePlanCountry } = useFreePlan();
  const ctaHref = useCtaHref();
  return (
    <div className='mx-4'>
      <div
        aria-label='User statistics and call to action'
        className='mx-auto mt-16 flex max-w-[1600px] flex-col items-center gap-6 rounded-2xl bg-azure-525/5 p-12 lg:flex-row lg:justify-between'
        role='banner'
      >
        <div className='flex flex-col items-center lg:flex-row lg:items-center lg:gap-4'>
          <div className='flex flex-col items-center gap-1.5 lg:flex-row'>
            <span className='text-base font-black lg:mr-4 lg:text-2xl'>
              {m.homepage_banner_trusted_by()}
            </span>
            <div className='relative rounded-full'>
              <div
                aria-label='User count'
                className='gradient-border relative rounded-full px-4 py-1.5 text-2xl font-bold'
              >
                <span className='relative z-10 text-nowrap'>
                  {m.homepage_banner_user_count()}
                </span>
              </div>
            </div>
          </div>
          <span className='mt-2 text-center text-base font-medium whitespace-normal text-neutral-385 lg:mt-0 lg:text-center'>
            {m.homepage_banner_subtitle()}
          </span>
        </div>

        <Button
          asChild
          className='w-full rounded-3xl bg-white p-7 text-base font-semibold text-black hover:bg-white/70 lg:w-auto'
        >
          <Link aria-label='Start your free account' to={ctaHref}>
            {isInFreePlanCountry
              ? m.homepage_banner_cta_free()
              : m.homepage_banner_cta()}
          </Link>
        </Button>
      </div>
    </div>
  );
}
